import { Component, Input } from '@angular/core';

@Component({
  selector: 'empty',
  templateUrl: 'empty.html'
})
export class EmptyComponent {

    @Input() message: string;
  	
    constructor(
    ) {}

  
}



// WEBPACK FOOTER //
// ./src/components/empty/empty.ts